import React from 'react';

interface ChordHintProps {
  palette: {
    panelText: string;
  };
  glass: React.CSSProperties;
  hint: string;
}

export function ChordHint({ palette, glass, hint }: ChordHintProps) {
  return (
    <div className="absolute bottom-20 left-1/2 z-50" style={{ transform: 'translateX(-50%)' }}>
      <div style={glass} className="backdrop-blur-md border rounded-xl px-5 py-2.5 shadow-xl">
        <span className="text-xs font-mono" style={{ color: palette.panelText }}>
          {hint}
        </span>
      </div>
    </div>
  );
}
